import React from 'react';
import { Link } from 'react-router-dom';
import CustomerHeader from '../../components/ui/CustomerHeader';
import Footer from '../../components/ui/Footer';
import Image from '../../components/AppImage';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import { useWishlist } from '../../context/WishlistContext';
import { useCart } from '../../context/CartContext';

export default function Wishlist() {
  const { items, remove, clear } = useWishlist();
  const cart = useCart();

  const handleAddToCart = (item) => {
    cart.addItem({
      id: item.id,
      name: item.name,
      price: item.price ?? 0,
      image: item.image,
      quantity: 1,
    });
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <CustomerHeader cartItemCount={cart.totalCount} />
      <div className="pt-20 pb-16 flex-1">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <div className="flex items-center justify-between mb-8">
            <h1 className="text-3xl font-heading font-semibold text-foreground">
              Your Wishlist {items.length > 0 && (
                <span className="text-muted-foreground text-xl">({items.length})</span>
              )}
            </h1>
            {items.length > 0 && (
              <button
                onClick={clear}
                className="text-sm text-muted-foreground hover:text-destructive transition-colors"
              >
                Clear all
              </button>
            )}
          </div>

          {items.length === 0 ? (
            <div className="bg-card border border-border rounded-2xl p-12 text-center">
              <Icon name="Heart" size={48} className="text-muted-foreground mx-auto mb-4" />
              <h2 className="text-lg font-medium text-foreground mb-1">No saved items yet</h2>
              <p className="text-sm text-muted-foreground mb-6">
                Tap the heart on any product you love and it'll show up here.
              </p>
              <Link
                to="/product-catalog"
                className="inline-flex items-center gap-2 text-primary hover:underline"
              >
                <Icon name="Store" size={16} />
                Browse the shop
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((item) => (
                <div key={item.id} className="bg-card border border-border rounded-xl overflow-hidden flex flex-col">
                  <Link to={`/product-details?id=${item.id}`} className="block aspect-square bg-muted">
                    {item.image && (
                      <Image src={item.image} alt={item.name} className="w-full h-full object-cover" />
                    )}
                  </Link>
                  <div className="p-4 flex-1 flex flex-col">
                    <Link
                      to={`/product-details?id=${item.id}`}
                      className="text-foreground font-medium hover:text-primary line-clamp-2 mb-1"
                    >
                      {item.name}
                    </Link>
                    <p className="text-lg font-bold text-foreground mb-3">
                      ${(item.price ?? 0).toFixed(2)}
                    </p>
                    <div className="mt-auto flex gap-2">
                      <Button
                        size="sm"
                        className="flex-1"
                        onClick={() => handleAddToCart(item)}
                      >
                        <Icon name="ShoppingCart" size={14} className="mr-1.5" />
                        Add to cart
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => remove(item.id)}
                        aria-label="Remove from wishlist"
                      >
                        <Icon name="Trash2" size={14} />
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
